import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Save01 } from '../../../assets';
import { ConfirmationDialog } from './ConfirmationDialog';
import { useTheme } from '@mui/material/styles';


export interface ModalProps {
  open: boolean;
  onConfirmUrl: string;
  onClose: () => void;
  onConfirm: () => void;
  navigateOnConfirm?: boolean;
  isProcessing?: boolean;
  onCancel?: () => void;
  leaveWarningTitle?: string;
  leaveWarningContent?: string;
}

const LeavePageModal = (props: ModalProps) => {

  const theme = useTheme();
  const navigate = useNavigate();
  const { t } = useTranslation('common');

  const handleConfirm = () => {
    if (props.navigateOnConfirm !== false) navigate(props.onConfirmUrl);
    props.onConfirm();
  };

  const handleCancel = () => {
    if (props.onCancel) {
      props.onCancel();
    } else {
      props.onClose();
    }
  };

  return <ConfirmationDialog open={props.open}
    message={t('leaveModalMessage')}
    onConfirm={handleConfirm}
    onCancel={handleCancel}
    isProcessing={props.isProcessing}
    icon={<Save01 color={theme.palette.warning[500]} />}
    title={t('unsavedChanges')}
    variant='primary'
    confirmButtonText={t('save')}
    cancelButtonText={t('discard')} />;
};

export default LeavePageModal;
